exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-container[data-v-3e6a7fdc]{background:#fff;padding:32px 16px}.pagination-container.hidden[data-v-3e6a7fdc]{display:none}", ""]);

// exports
